var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientOnly',[_c(_vm.icon,{tag:"component",class:_vm.classes,attrs:{"component-id":_vm.componentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }